import { ServiceGroup } from '../types/diagram.types';

// OSS-NETVIZ-2: палитра drag&drop. MIME-тип для передачи группы сервиса через
// dataTransfer (onDragStart в LeftPanel → onDrop в ServiceMapPage).
export const SERVICE_PALETTE_MIME = 'application/x-service-map-group';

// Группы сервисов, доступные для перетаскивания на холст (порядок = в палитре).
export const PALETTE_GROUPS: ServiceGroup[] = [
  'Gateways',
  'Auth/User',
  'Finance',
  'Trading',
  'Market Data',
  'Quick Exchange',
  'Acquiring',
  'Crypto',
  'Compliance',
  'Notifications',
  'Support',
];
